import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const ThresholdList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
`;

// Dimension section

export const DimensionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DimensionSection = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.2rem;
  gap: 1.6rem;
`;

export const DimensionData = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      user-select: none;

      > * {
        pointer-events: none;
      }
    `}
`;

export const DimensionIconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-right: 0.8rem;

  svg {
    width: 2rem;
    height: 2rem;
    path {
      stroke: ${vars.colors.grey40};
      color: ${vars.colors.grey40};
    }
  }
`;

export const DimensionName = styled(Paragraph)`
  color: ${vars.colors.grey30};
  font-weight: 500;
  min-width: 8.4rem;
  max-width: 8.4rem;
  flex: 1;
  word-wrap: break-word;
`;

// Category rows

export const CategoryRows = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  flex: 1;
  flex-wrap: wrap;
`;

export const AddCategoryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  border-radius: 1rem;
  cursor: pointer;
  overflow: hidden;
  width: 2.8rem;
  height: 2.8rem;
`;

// Category chip

export const CategoryChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  border-radius: 1rem;
  padding: 0.4rem 0.5rem 0.4rem 1rem;
  cursor: pointer;
  height: 2.8rem;
`;

export const CategoryChipName = styled(Paragraph)`
  color: ${vars.colors.grey30};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
`;

export const CategoryChipMinimumInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  color: ${vars.colors.grey60};
  padding: 0.4rem;
  font-size: 1.4rem;
  font-style: italic;
  font-weight: 500;
  width: 3.4rem;
  height: 2.2rem;
  border-radius: 0.6rem;

  &:focus {
    background: ${vars.colors.black};
    border: 1px solid ${vars.colors.purple};
  }
`;

export const RemoveCategoryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${vars.colors.transparent};

  &:hover {
    svg {
      path {
        stroke: ${vars.colors.red};
        color: ${vars.colors.red};
      }
    }
  }
`;
